<template>
  <div>
    <h1>创建班次表</h1>
    <el-form label-width="120px" @submit.native.prevent="creategrade">
      <el-form-item label="选择网校">
        <el-select
          clearable
          v-model="model.maID"
          placeholder="网校"
          @change="getPrice"
        >
          <el-option
            v-for="item in major"
            :key="item.maID"
            :label="item.maName"
            :value="item.maID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="一级分类">
        <el-select
          v-model="model.chID"
          multiple
          placeholder="一级分类"
          @change="getCourse"
        >
          <el-option
            v-for="item in channel"
            :key="item.chID"
            :label="item.chName"
            :value="item.chID"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="二级分类">
        <el-select
          v-model="model.coID"
          multiple
          @change="getClass"
          placeholder="二级分类"
        >
          <el-option
            v-for="item in course"
            :key="item.coID"
            :label="item.coName"
            :value="item.coID"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="三级分类">
        <el-select
          v-model="model.clID"
          @change="getPrice"
          multiple
          placeholder="三级分类"
        >
          <el-option
            v-for="item in clclass"
            :key="item.clID"
            :label="item.clName"
            :value="item.clID"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="班次年份">
        <el-input v-model="model.grYear"></el-input>
      </el-form-item>

      <el-form-item label="班次名称">
        <el-input v-model="model.grName"></el-input>
      </el-form-item>
      <!-- <el-form-item label="grID">
        <el-input v-model="model.grID"></el-input>
      </el-form-item> -->

      <!-- <el-form-item label="单独笔试价格">
            <el-input v-model="model.grTestPrice"></el-input>
          </el-form-item> -->
      <el-form-item label="班次价格">
        <el-input v-model="model.grPrice"></el-input>
      </el-form-item>
      <el-form-item label="销售价格">
        <el-input v-model="model.salePrice"></el-input>
      </el-form-item>

      <el-form-item label="选择视频课程">
        <el-select v-model="model.prVideoName" multiple placeholder="视频课程">
          <el-option
            v-for="item in prvideo"
            :key="item.prvideoId"
            :label="item.prVideoName"
            :value="item.prVideoName"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="选择电子资料">
        <el-select v-model="model.prPdfName" multiple placeholder="电子资料">
          <el-option
            v-for="item in prpdf"
            :key="item.prPdfId"
            :label="item.prPdfName"
            :value="item.prPdfName"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="选择教学服务">
        <el-select
          v-model="model.prServiceName"
          multiple
          placeholder="教学服务"
        >
          <el-option
            v-for="item in prservice"
            :key="item.prServiceId"
            :label="item.prServiceName"
            :value="item.prServiceName"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="选择听课方式">
        <el-select v-model="model.prTeachWayName" placeholder="听课方式">
          <el-option
            v-for="item in prteachway"
            :key="item.prTeachWayId"
            :label="item.prTeachWayName"
            :value="item.prTeachWayName"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="选择学习期限">
        <el-select v-model="model.prTeachTimeName" placeholder="学习期限">
          <el-option
            v-for="item in prteachtime"
            :key="item.prTeachTimeId"
            :label="item.prTeachTimeName"
            :value="item.prTeachTimeName"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" native-type="submit">点击创建</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      major: [],
      channel: [],
      course: [],
      clclass: [],
      grade: {},
      model: {},
      prpdf: {},
      prservice: {},
      prvideo: {},
      prteachway: {},
      prteachtime: {},
      maID: "",
      chID: "",
      coID: "",
      clID: "",
    };
  },
  methods: {
    async creategrade() {
      try {
        const createGrade = await this.$http.post(
          "/category/creategrade",
          this.model
        );
        //this.$router.push("/categories/list");
        if (createGrade.status == 200) {
          this.$message({
            type: "success",
            message: createGrade.data.msg,
          });
          this.$router.push("/grade/list");
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getMajor() {
      try {
        const getmajor = await this.$http.get("/major/getmajor");
        this.major = getmajor.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getChannel() {
      try {
        const getchannel = await this.$http.get("/category/getchannel");
        //console.log(getchannel.data);
        this.channel = getchannel.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getCourse(chID) {
      try {
        const getcourse = await this.$http.get("/category/getcourse", {
          params: { chID },
        });
        this.course = getcourse.data;
        this.getPrice(chID);
        //this.getGrade();
      } catch (error) {
        console.log(error);
      }
    },
    async getClass(coID) {
      try {
        const getclass = await this.$http.get("/category/getclass", {
          params: { coID },
        });
        this.clclass = getclass.data;
        this.getPrice(coID);
      } catch (error) {
        console.log(error);
      }
    },
    async getPrice() {
      try {
        let params = {
          chID: this.model.chID,
          maID: this.model.maID,
          coID: this.model.coID,
        };
        //console.log(params);
        const getprice = await this.$http.get("/category/getgrprice", {
          params,
        });
        //console.log(getprice.data[0].result);
        this.prpdf = getprice.data[0].prpdf;
        this.prservice = getprice.data[0].prservice;
        this.prvideo = getprice.data[0].prvideo;
        this.prteachway = getprice.data[0].prteachway;
        this.prteachtime = getprice.data[0].prteachtime;
        //console.log(this.prpdf);
      } catch (error) {
        console.log(error);
      }
    },
  },
  created() {
    this.getMajor();
    this.getChannel();
    //this.gradeDelete();
  },
};
</script>
